module.exports = __webpack_public_path__ + "static/img/3.a117123.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/10/sp/3.png
// module id = gGqz
// module chunks = 0